export { default } from './VoiceAssistant';
